import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../api/api';
import axios from 'axios';
import { api_url } from '../../utils/utils'
// ✅ Get shop info
export const get_shop_info = createAsyncThunk(
    'seller/get_shop_info',
    async (_, { rejectWithValue, getState }) => {
        // const token = getState().auth.token;
        // const config = {
        //     headers: {
        //         'Authorization': `Bearer ${token}`
        //     }
        // };
        try {
            const { data } = await axios.get(`${api_url}/api/seller/shop/info`, {withCredentials: true} /*config*/);
            return data;
        } catch (error) {
            return rejectWithValue(error.response?.data || { message: 'Shop info alınmadı' });
        }
    }
);

// ✅ Update shop info
export const update_shop_info = createAsyncThunk(
    'seller/update_shop_info',
    async (shopData, { rejectWithValue, getState }) => {
                // const token = getState().auth.token;
                // const config = {
                //     headers: {
                //         'Authorization': `Bearer ${token}`
                //     }
                // };
        try {
            const { data } = await api.put(`/seller/shop/update`, shopData, {withCredentials: true});
            return data;
        } catch (error) {
            return rejectWithValue(error.response?.data || { message: 'Yeniləmə uğursuz oldu' });
        }
    }
);

// ✅ Upload logo
export const upload_logo = createAsyncThunk(
    'seller/upload_logo',
    async (formData, { rejectWithValue, getState }) => {
        // const token = getState().auth.token;
        // const config = {
        //     headers: {
        //         'Authorization': `Bearer ${token}`
        //     }
        // };
        try {
            const { data } = await api.post(`/seller/shop/upload-logo`, formData, {withCredentials: true});
            return data;
        } catch (error) {
            return rejectWithValue(error.response?.data || { message: 'Logo yüklənmədi' });
        }
    }
);

// ✅ Upload cover
export const upload_cover = createAsyncThunk(
    'seller/upload_cover',
    async (formData, { rejectWithValue, getState }) => {
        // const token = getState().auth.token;
        // const config = {
        //     headers: {
        //         'Authorization': `Bearer ${token}`
        //     }
        // };
        try {
            const { data } = await api.post(`/seller/shop/upload-cover`, formData, {withCredentials: true});
            return data;
        } catch (error) {
            return rejectWithValue(error.response?.data || { message: 'Cover yüklənmədi' });
        }
    }
);

// ✅ Change frame
export const change_frame = createAsyncThunk(
    'seller/change_frame',
    async (frameData, { rejectWithValue, getState }) => {
        // const token = getState().auth.token;
        // const config = {
        //     headers: {
        //         'Authorization': `Bearer ${token}`
        //     }
        // };
        try {
            const { data } = await api.put(`/seller/shop/change-frame`, frameData, {withCredentials: true});
            return data;
        } catch (error) {
            return rejectWithValue(error.response?.data || { message: 'Frame dəyişdirilmədi' });
        }
    }
);

// ✅ Get unlocked frames
export const get_unlocked_frames = createAsyncThunk(
    'seller/get_unlocked_frames',
    async (_, { rejectWithValue, getState }) => {
        // const token = getState().auth.token;
        // const config = {
        //     headers: {
        //         'Authorization': `Bearer ${token}`
        //     }
        // };
        try {
            const { data } = await axios.get(`${api_url}/api/seller/shop/frames`, {withCredentials: true});
            return data;
        } catch (error) {
            return rejectWithValue(error.response?.data || { message: 'Frames alınmadı' });
        }
    }
);

// ✅ Update banner
export const update_banner = createAsyncThunk(
    'seller/update_banner',
    async (bannerData, { rejectWithValue, getState }) => {
        // const token = getState().auth.token;
        // const config = {
        //     headers: {
        //         'Authorization': `Bearer ${token}`
        //     }
        // };
        try {
            const { data } = await api.put(`/seller/shop/banner`, bannerData, {withCredentials: true});
            return data;
        } catch (error) {
            return rejectWithValue(error.response?.data || { message: 'Banner yenilənmədi' });
        }
    }
);

const sellerShopReducer = createSlice({
    name: 'sellerShop',
    initialState: {
        shopInfo: {
            shopName: '',
            username: '',
            description: '',
            logo: '',
            coverImage: '',
            activeFrame: { frameId: 1 },
            socialLinks: {},
            banner: {
                enabled: false,
                text: '',
                bgColor: '#3b82f6',
                textColor: '#ffffff'
            }
        },
        unlockedFrames: [],
        loading: false,
        uploadingLogo: false,
        uploadingCover: false,
        errorMessage: '',
        successMessage: ''
    },
    reducers: {
        messageClear: (state) => {
            state.errorMessage = '';
            state.successMessage = '';
        }
    },
    extraReducers: (builder) => {
        builder
            // Get shop info
            .addCase(get_shop_info.pending, (state) => {
                state.loading = true;
            })
            .addCase(get_shop_info.fulfilled, (state, { payload }) => {
                state.loading = false;
                state.shopInfo = payload.shopInfo;
            })
            .addCase(get_shop_info.rejected, (state, { payload }) => {
                state.loading = false;
                state.errorMessage = payload?.message || 'Xəta baş verdi';
            })
            
            // Update shop info
            .addCase(update_shop_info.pending, (state) => {
                state.loading = true;
            })
            .addCase(update_shop_info.fulfilled, (state, { payload }) => {
                state.loading = false;
                state.shopInfo = { ...state.shopInfo, ...payload.shopInfo };
                state.successMessage = 'Mağaza məlumatları yeniləndi!';
            })
            .addCase(update_shop_info.rejected, (state, { payload }) => {
                state.loading = false;
                state.errorMessage = payload?.message || 'Yeniləmə uğursuz oldu';
            })
            
            // Upload logo
            .addCase(upload_logo.pending, (state) => {
                state.uploadingLogo = true;
            })
            .addCase(upload_logo.fulfilled, (state, { payload }) => {
                state.uploadingLogo = false;
                state.shopInfo.logo = payload.logo;
                state.successMessage = 'Logo yükləndi!';
            })
            .addCase(upload_logo.rejected, (state, { payload }) => {
                state.uploadingLogo = false;
                state.errorMessage = payload?.message || 'Logo yüklənmədi';
            })
            
            // Upload cover
            .addCase(upload_cover.pending, (state) => {
                state.uploadingCover = true;
            })
            .addCase(upload_cover.fulfilled, (state, { payload }) => {
                state.uploadingCover = false;
                state.shopInfo.coverImage = payload.coverImage;
                state.successMessage = 'Cover şəkil yükləndi!';
            })
            .addCase(upload_cover.rejected, (state, { payload }) => {
                state.uploadingCover = false;
                state.errorMessage = payload?.message || 'Cover yüklənmədi';
            })
            
            // Change frame
            .addCase(change_frame.fulfilled, (state, { payload }) => {
                state.shopInfo.activeFrame = payload.activeFrame;
                state.successMessage = 'Frame dəyişdirildi!';
            })
            .addCase(change_frame.rejected, (state, { payload }) => {
                state.errorMessage = payload?.message || 'Frame dəyişdirilmədi';
            })
            
            // Get unlocked frames
            .addCase(get_unlocked_frames.fulfilled, (state, { payload }) => {
                state.unlockedFrames = payload.unlockedFrames;
                state.shopInfo.activeFrame = payload.activeFrame;
            })
            
            // Update banner
            .addCase(update_banner.fulfilled, (state, { payload }) => {
                state.shopInfo.banner = payload.banner;
                state.successMessage = 'Banner yeniləndi!';
            })
            .addCase(update_banner.rejected, (state, { payload }) => {
                state.errorMessage = payload?.message || 'Banner yenilənmədi';
            });
    }
});

export const { messageClear } = sellerShopReducer.actions;
export default sellerShopReducer.reducer;